import './S_Dropzone.scss';
import classNames from 'classnames';
import { PropsWithChildren, ReactElement } from 'react';
import { DropzoneOptions, useDropzone } from 'react-dropzone';

interface IDropzoneProps extends PropsWithChildren, DropzoneOptions {
  className?: string;
}

export const S_Dropzone = ({ className, children, ...rest }: IDropzoneProps): ReactElement => {
  const { getRootProps, getInputProps, isDragAccept } = useDropzone(rest);

  return (
    <div
      {...getRootProps()}
      className={classNames('s-dropzone', className, { 'dragged-on': isDragAccept })}
    >
      <input {...getInputProps()} />
      {children}
    </div>
  );
};
